// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function actor_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var email_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email_id"), null));
    if (email_id.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                name: name._0,
                email_id: email_id._0
              }
            };
    }
    var e = email_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".email_id" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function creation_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var actor = actor_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "actor"), null));
  if (actor.TAG === /* Ok */0) {
    var time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "time"), null));
    if (time.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                actor: actor._0,
                time: time._0
              }
            };
    }
    var e = time._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".time" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = actor._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".actor" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function approval_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var actor = actor_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "actor"), null));
  if (actor.TAG === /* Ok */0) {
    var time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "time"), null));
    if (time.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                actor: actor._0,
                time: time._0
              }
            };
    }
    var e = time._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".time" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = actor._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".actor" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function allocation_filter_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var auto = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "auto"), null));
  if (auto.TAG === /* Ok */0) {
    var manual = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "manual"), null));
    if (manual.TAG === /* Ok */0) {
      var threshold = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "threshold"), null));
      if (threshold.TAG === /* Ok */0) {
        var ratio = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "ratio"), null));
        if (ratio.TAG === /* Ok */0) {
          var radius_delta = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "radius_delta"), null));
          if (radius_delta.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      auto: auto._0,
                      manual: manual._0,
                      threshold: threshold._0,
                      ratio: ratio._0,
                      radius_delta: radius_delta._0
                    }
                  };
          }
          var e = radius_delta._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".radius_delta" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = ratio._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".ratio" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = threshold._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".threshold" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = manual._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".manual" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = auto._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".auto" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function validation_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var validation_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "validation_type"), null));
  if (validation_type.TAG === /* Ok */0) {
    var segment_names = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "segment_names"), null));
    if (segment_names.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                validation_type: validation_type._0,
                segment_names: segment_names._0
              }
            };
    }
    var e = segment_names._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".segment_names" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = validation_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".validation_type" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function validations_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var validations = Decco.arrayFromJson(validation_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "validations"), null));
  if (validations.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              validations: validations._0
            }
          };
  }
  var e = validations._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".validations" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function campaign_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var geo_region_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
      if (geo_region_id.TAG === /* Ok */0) {
        var vehicle_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_id"), null));
        if (vehicle_id.TAG === /* Ok */0) {
          var _type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
          if (_type.TAG === /* Ok */0) {
            var sub_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_type"), null));
            if (sub_type.TAG === /* Ok */0) {
              var zone_ids = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "zone_ids"), null));
              if (zone_ids.TAG === /* Ok */0) {
                var cluster_ids = Decco.optionFromJson((function (param) {
                        return Decco.arrayFromJson(Decco.intFromJson, param);
                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "cluster_ids"), null));
                if (cluster_ids.TAG === /* Ok */0) {
                  var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
                  if (status.TAG === /* Ok */0) {
                    var priority = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "priority"), null));
                    if (priority.TAG === /* Ok */0) {
                      var pending_priority = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pending_priority"), null));
                      if (pending_priority.TAG === /* Ok */0) {
                        var effective_from = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "effective_from"), null));
                        if (effective_from.TAG === /* Ok */0) {
                          var effective_till = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "effective_till"), null));
                          if (effective_till.TAG === /* Ok */0) {
                            var days_of_week = Decco.listFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "days_of_week"), null));
                            if (days_of_week.TAG === /* Ok */0) {
                              var day_start_hour = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "day_start_hour"), null));
                              if (day_start_hour.TAG === /* Ok */0) {
                                var day_start_min = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "day_start_min"), null));
                                if (day_start_min.TAG === /* Ok */0) {
                                  var day_end_hour = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "day_end_hour"), null));
                                  if (day_end_hour.TAG === /* Ok */0) {
                                    var day_end_min = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "day_end_min"), null));
                                    if (day_end_min.TAG === /* Ok */0) {
                                      var values = allocation_filter_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "values"), null));
                                      if (values.TAG === /* Ok */0) {
                                        var creation_info = creation_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "creation_info"), null));
                                        if (creation_info.TAG === /* Ok */0) {
                                          var approval_info = Decco.optionFromJson(approval_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "approval_info"), null));
                                          if (approval_info.TAG === /* Ok */0) {
                                            var validation = Decco.optionFromJson(validations_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "validation"), null));
                                            if (validation.TAG === /* Ok */0) {
                                              return {
                                                      TAG: /* Ok */0,
                                                      _0: {
                                                        id: id._0,
                                                        name: name._0,
                                                        geo_region_id: geo_region_id._0,
                                                        vehicle_id: vehicle_id._0,
                                                        _type: _type._0,
                                                        sub_type: sub_type._0,
                                                        zone_ids: zone_ids._0,
                                                        cluster_ids: cluster_ids._0,
                                                        status: status._0,
                                                        priority: priority._0,
                                                        pending_priority: pending_priority._0,
                                                        effective_from: effective_from._0,
                                                        effective_till: effective_till._0,
                                                        days_of_week: days_of_week._0,
                                                        day_start_hour: day_start_hour._0,
                                                        day_start_min: day_start_min._0,
                                                        day_end_hour: day_end_hour._0,
                                                        day_end_min: day_end_min._0,
                                                        values: values._0,
                                                        creation_info: creation_info._0,
                                                        approval_info: approval_info._0,
                                                        validation: validation._0
                                                      }
                                                    };
                                            }
                                            var e = validation._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".validation" + e.path,
                                                      message: e.message,
                                                      value: e.value
                                                    }
                                                  };
                                          }
                                          var e$1 = approval_info._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".approval_info" + e$1.path,
                                                    message: e$1.message,
                                                    value: e$1.value
                                                  }
                                                };
                                        }
                                        var e$2 = creation_info._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".creation_info" + e$2.path,
                                                  message: e$2.message,
                                                  value: e$2.value
                                                }
                                              };
                                      }
                                      var e$3 = values._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".values" + e$3.path,
                                                message: e$3.message,
                                                value: e$3.value
                                              }
                                            };
                                    }
                                    var e$4 = day_end_min._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".day_end_min" + e$4.path,
                                              message: e$4.message,
                                              value: e$4.value
                                            }
                                          };
                                  }
                                  var e$5 = day_end_hour._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".day_end_hour" + e$5.path,
                                            message: e$5.message,
                                            value: e$5.value
                                          }
                                        };
                                }
                                var e$6 = day_start_min._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".day_start_min" + e$6.path,
                                          message: e$6.message,
                                          value: e$6.value
                                        }
                                      };
                              }
                              var e$7 = day_start_hour._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".day_start_hour" + e$7.path,
                                        message: e$7.message,
                                        value: e$7.value
                                      }
                                    };
                            }
                            var e$8 = days_of_week._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".days_of_week" + e$8.path,
                                      message: e$8.message,
                                      value: e$8.value
                                    }
                                  };
                          }
                          var e$9 = effective_till._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".effective_till" + e$9.path,
                                    message: e$9.message,
                                    value: e$9.value
                                  }
                                };
                        }
                        var e$10 = effective_from._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".effective_from" + e$10.path,
                                  message: e$10.message,
                                  value: e$10.value
                                }
                              };
                      }
                      var e$11 = pending_priority._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".pending_priority" + e$11.path,
                                message: e$11.message,
                                value: e$11.value
                              }
                            };
                    }
                    var e$12 = priority._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".priority" + e$12.path,
                              message: e$12.message,
                              value: e$12.value
                            }
                          };
                  }
                  var e$13 = status._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".status" + e$13.path,
                            message: e$13.message,
                            value: e$13.value
                          }
                        };
                }
                var e$14 = cluster_ids._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".cluster_ids" + e$14.path,
                          message: e$14.message,
                          value: e$14.value
                        }
                      };
              }
              var e$15 = zone_ids._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".zone_ids" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                      }
                    };
            }
            var e$16 = sub_type._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".sub_type" + e$16.path,
                      message: e$16.message,
                      value: e$16.value
                    }
                  };
          }
          var e$17 = _type._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".type" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
        }
        var e$18 = vehicle_id._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".vehicle_id" + e$18.path,
                  message: e$18.message,
                  value: e$18.value
                }
              };
      }
      var e$19 = geo_region_id._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".geo_region_id" + e$19.path,
                message: e$19.message,
                value: e$19.value
              }
            };
    }
    var e$20 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$20.path,
              message: e$20.message,
              value: e$20.value
            }
          };
  }
  var e$21 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$21.path,
            message: e$21.message,
            value: e$21.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var campaigns = Decco.listFromJson(campaign_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "campaigns"), null));
  if (campaigns.TAG === /* Ok */0) {
    var total_count = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "total_count"), null));
    if (total_count.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                campaigns: campaigns._0,
                total_count: total_count._0
              }
            };
    }
    var e = total_count._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".total_count" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = campaigns._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".campaigns" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  actor_decode ,
  creation_info_decode ,
  approval_info_decode ,
  allocation_filter_decode ,
  validation_decode ,
  validations_decode ,
  campaign_decode ,
  t_decode ,
  
}
/* No side effect */
